import { useMemo } from 'react'

import SelectRow from '@dc-shared-web/components/features/AIConfigDialog/SelectRow'
import { getModels } from '@dc-shared-web/components/features/AIConfigDialog/helpers'
import {
  AIConfigModalProvider,
  AIConfigModalValues,
} from '@dc-shared-web/components/features/AIConfigDialog/types'

const LanguageModelRow = ({
  values,
  disabled,
  providers,
  onChange,
}: {
  values: AIConfigModalValues
  providers: AIConfigModalProvider[]
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const models = useMemo(
    () => getModels(values.provider, providers),
    [values.provider, providers]
  )

  const handleChange = (value: string) => {
    onChange({ ...values, model: value })
  }

  return (
    <SelectRow
      label='Language model'
      value={values.model}
      options={models.map((model) => ({
        value: model.id,
        text: model.name,
      }))}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}

export default LanguageModelRow
